import { IJsonTabNode } from "flexlayout-react";
import { createModel, RematchRootState } from "@rematch/core";
import { Dispatch } from "redux";
import { KoreModel } from "./";
import axios from "axios";

interface PluginsCustomData {
  layoutId: string;
  pluginName: string;
  data: Record<string, any>;
  isOriginalValue: boolean;
}

interface LayoutData {
  LayoutName: string;
  IDContact: number;
  Global: boolean;
  GlobalRight: boolean;
  overwrite: boolean;
  IDLayout: number;
  icon: string;
  LayoutData: string;
  updateData: boolean;
}

const model = {
  name: "pluginsCustomData",
  state: [] as PluginsCustomData[],
  reducers: {
    addData: (currentState: PluginsCustomData[], pluginAttributes: IJsonTabNode, addedProperties: Record<string, unknown>) => {
      const layoutId = pluginAttributes.id;

      // Flag le data comme étant à sauvegarder
      delete addedProperties.isOriginalValue;

      let currentData = {};

      if (currentState[layoutId]) currentData = currentState[layoutId].data;

      return { ...currentState, [layoutId]: { layoutId, pluginName: pluginAttributes.component, data: { ...currentData, ...addedProperties } } };
    },
    loadSavedData: (currentState: PluginsCustomData[], pluginAttributes: IJsonTabNode, addedProperties: Record<string, unknown>) => {
      const layoutId = pluginAttributes.id;

      // Ajout de isUpdated = true pour dire qu'on a pas besoin de le sauvegarder avant une modification lors du save de layout
      return { ...currentState, [layoutId]: { layoutId, data: addedProperties, isOriginalValue: true } };
    },
    removeData: (currentState: PluginsCustomData[], pluginLayoutId: string) => {
      const layoutId = pluginLayoutId;
      const newState = { ...currentState };

      if (currentState[layoutId]) newState[layoutId] = {};

      return newState;
    },
    removeDataProperty: (currentState: PluginsCustomData[], pluginLayoutId: string, property: string) => {
      const layoutId = pluginLayoutId;
      const newStateData = { ...currentState[layoutId] };

      delete newStateData.data[property];

      return { ...currentState, [layoutId]: newStateData };
    },
    deleteData: (currentState: PluginsCustomData[], pluginLayoutId: string) => {
      const newState = { ...currentState };

      delete newState[pluginLayoutId];

      return newState;
    },
    removeAllData: () => []
  },
  effects: (dispatch: Dispatch) => {
    return {
      async saveData(layoutData: LayoutData, state: RematchRootState<KoreModel>) {
        const pluginCustomDataToSave = Object.fromEntries(Object.entries(state.pluginsCustomData).filter(([key, value]) => !value.isOriginalValue));
        const sendData = { layoutData, pluginCustomDataToSave };

        if (Object.keys(pluginCustomDataToSave).length > 0) {
          try {
            await axios.post("/Desktop/savePluginsCustomData", sendData);

            Object.entries(pluginCustomDataToSave).forEach(([key, value]) => {
              if (value && Object.keys(value).length > 0) {
                const pluginAttributes = { id: value.layoutId, component: value.pluginName };

                dispatch.pluginsCustomData.loadSavedData(pluginAttributes, value.data);
              } else dispatch.pluginsCustomData.deleteData(key);
            });
          } catch (error) {
            console.error(`Erreur lors du saveData de pluginsCustomData : ${error}`);
          }
        }
      },
      async getData(IDLayout: number) {
        const { data } = await axios.get("/Desktop/getPluginsCustomData", { params: { IDLayout } });

        if (data) {
          data.forEach((profileConfiguration: PluginsCustomData) => {
            try {
              dispatch.pluginsCustomData.loadSavedData(
                { id: profileConfiguration.layoutId, component: { component: profileConfiguration.pluginName } },
                profileConfiguration.data
              );
            } catch (error) {
              console.error(`Error while trying to getPluginsCustomData : ${error}`);
            }
          });
        }
      }
    };
  }
};

export const pluginsCustomDataModel = createModel<KoreModel>()(model);
